// Inscription Web Push (PWA).
import { api } from "./api";

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (e) {
    console.error("SW register failed", e);
    return null;
  }
}

export async function subscribePush(): Promise<boolean> {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const reg = await navigator.serviceWorker.ready;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return false;

  const { key } = await api<{ key: string }>("/push/public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    // Cast vers BufferSource — TS strict refuse Uint8Array<ArrayBufferLike> en l'état
    const appKey = urlBase64ToUint8Array(key) as unknown as BufferSource;
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appKey,
    });
  }
  const j = sub.toJSON() as {
    endpoint: string;
    keys: { p256dh: string; auth: string };
  };
  await api("/push/subscribe", { method: "POST", json: j });
  return true;
}

export async function unsubscribePush(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api("/push/unsubscribe", {
      method: "POST",
      json: { endpoint: sub.endpoint },
    });
    await sub.unsubscribe();
  }
}

export async function pushStatus(): Promise<"granted" | "denied" | "default" | "unsupported"> {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
}
